import { Collapse, Empty, Radio, Spin } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { showError } from "../utils";
import {
  PatchNoteReleaseDetail,
  ReleaseHeader,
} from "./PatchNoteReleaseDetail";
import {
  fetchPatchNotesManifest,
  getVisibleReleases,
  PatchNoteRelease,
  ReleaseChannel,
} from "../utils/patchNotes";

const { Panel } = Collapse;

export const PatchNotesList = () => {
  const [manifestReleases, setManifestReleases] = useState<PatchNoteRelease[]>(
    []
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();
  const [channel, setChannel] = useState<ReleaseChannel>("latest");
  const [openReleaseId, setOpenReleaseId] = useState<string>();

  useEffect(() => {
    const fetchManifest = async () => {
      setLoading(true);
      setError(undefined);
      try {
        const manifest = await fetchPatchNotesManifest();
        setManifestReleases(manifest.releases || []);
      } catch (err) {
        setError("Failed to load patch notes.");
        showError("Failed to load patch notes", err);
      } finally {
        setLoading(false);
      }
    };
    fetchManifest();
  }, []);

  const visibleReleases = useMemo(
    () => getVisibleReleases(manifestReleases, channel),
    [manifestReleases, channel]
  );

  if (loading) {
    return (
      <div className="patch-notes patch-notes--loading">
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="patch-notes">
        <Empty description={error} />
      </div>
    );
  }

  return (
    <div className="patch-notes">
      <div className="patch-notes-toolbar">
        <span className="patch-notes-toolbar-label">Release channel</span>
        <Radio.Group
          value={channel}
          onChange={(e) => setChannel(e.target.value)}
          buttonStyle="solid"
          size="small"
        >
          <Radio.Button value="latest">Latest</Radio.Button>
          <Radio.Button value="beta">Beta</Radio.Button>
          <Radio.Button value="alpha">Alpha</Radio.Button>
        </Radio.Group>
      </div>

      <div className="patch-notes-list">
        {visibleReleases.length === 0 ? (
          <Empty description="No patch notes for this channel." />
        ) : (
          <Collapse
            className="patch-notes-collapse"
            accordion
            bordered={false}
            onChange={(keys) => {
              const key = Array.isArray(keys) ? keys[0] : keys;
              setOpenReleaseId(key);
            }}
          >
            {visibleReleases.map((release) => (
              <Panel
                key={release.id}
                header={
                  <ReleaseHeader
                    release={release}
                    showCopyLink
                    titleAsLink
                  />
                }
              >
                {openReleaseId === release.id && (
                  <PatchNoteReleaseDetail
                    release={release}
                    showHeader={false}
                  />
                )}
              </Panel>
            ))}
          </Collapse>
        )}
      </div>
    </div>
  );
};
